module.exports = __webpack_public_path__ + "static/media/hermeus-thumbnail.677bf243.jpg";